// src/modules/guest/registration/routes/index.ts
import type { RouteRecordRaw } from 'vue-router'

export const registrationRoutes: RouteRecordRaw[] = [
  {
    path: '/events/registration/:inviteKey',
    name: 'accept-invite',
    component: () =>
      import('@/modules/guest/registration/views/FormInvite.vue'),
    props: true,
    meta: { requiresAuth: true }, // privada
  },
  {
    path: '/events/public-registration/:eventId',
    name: 'public-invite',
    component: () =>
      import('@/modules/guest/registration/views/PublicInvite.vue'),
    props: true,
    meta: { public: true }, // <-- ESSENCIAL
  },
]
